module.exports = __webpack_public_path__ + "img/dianshanbg.5ebff389.jpg";